// src/styles/theme.ts
import { shade } from 'polished';

export default {
  title: 'default',

  colors: {
    primary: '#be7e38',
    primary_dark: shade(0.2, '#be7e38'), // Usando polished para escurecer a cor primária

    background: '#F0F2F5',
    card_background: '#FFFFFF',
    text: '#333',
    text_light: '#666360',
    white: '#FFFFFF',
    error: '#c53030',
  },
};
